import { Component } from '@angular/core';

import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'apm-tab-wrapper',
  templateUrl: './tab-wrapper.component.html',
  styleUrls: ['./tab-wrapper.component.scss'],
  standalone: false,
})
export class TabWrapperComponent extends FieldWrapper {
  isValid(field: any) {
    if (field.key) {
      return field?.formControl?.valid;
    }
    return field?.every(f => this.isValid(f));
  }
}
